import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../restauration.png'


const _hoisted_1 = { class: "p-0 text-grey-900" }
const _hoisted_2 = { class: "plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5" }
const _hoisted_3 = { class: "d-flex justify-content-between" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "title-2 text-grey-900" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_8 = ["innerHTML"]

import { onMounted } from "vue";

// Classes
import { ClubAdvantage } from "../classes/ClubAdvantage";

// Components
import BorderHorizontal from "@/vue/common/borderHorizontal.vue";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultPopUp',
  props: {
    advantage: {}
  },
  emits: ["closePopup"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Methods
const handleClose = (): void => {
	emit("closePopup");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(props.advantage.cardTitleIcon), {
              width: 32,
              height: 32
            }))
          ]),
          _createElementVNode("div", _hoisted_6, _toDisplayString(props.advantage.title), 1)
        ]),
        _createElementVNode("button", {
          class: "ts-x-black ts-x-md",
          onClick: handleClose
        })
      ]),
      _createVNode(BorderHorizontal),
      (props.advantage.cardImage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "",
              class: "w-100"
            }, null, -1)
          ])))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        innerHTML: props.advantage.cardContent
      }, null, 8, _hoisted_8)
    ])
  ]))
}
}

})